import { render } from "./OperatorsView.vue?vue&type=template&id=2542df8e&scoped=true"
import script from "./OperatorsView.vue?vue&type=script&lang=js"
export * from "./OperatorsView.vue?vue&type=script&lang=js"

import "./OperatorsView.vue?vue&type=style&index=0&id=2542df8e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2542df8e"]])

export default __exports__